import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {property} from 'lit/decorators/property.js';
import {FeatureSelectItem} from './featureSelectItem';
import arrowDown from '../../../icons/arrow-down';

@customElement('feature-choice-select-item')
export class FeatureComboSelectItem extends FeatureSelectItem {

	@property({type: Boolean})
	active = false;

	@property({type: Boolean})
	satisfied = false;

	static styles = [
		FeatureSelectItem.styles,
		css`
			@keyframes reveal {
				0% {
					height: 0;
					opacity: 0;
				}

				100% {
					height: var(--height-widget);
					opacity: 100%;
				}
			}
			@keyframes hide {
				0% {
					height: var(--height-widget);
					opacity: 100%;
				}
				100% {
					height: 0;
					opacity: 0;
				}
			}

			:host {
				list-style: none;
			}

			.item {
				position: relative;
			}

			.item button {
				display: none;
				overflow: hidden;

				height: 0;
				opacity: 0;
				border: 0 none;
				padding: 0 0.5em;

				min-height: initial;
				transition: background-color 0.4s, color 0.4s, height 0.25s ease-out, opacity 0.25s, padding 0.25s;
				line-height: 120%;
				margin: 0;
				cursor: pointer;
				width: 100%;
				text-align: left;
			}

			button:hover {
				color: var(--color-white);
			}
			.item.disabled.hideDisabled button {
				display: none
			}
			.selected button {
				height: var(--height-widget);
				opacity: 1;
				color: var(--color-text-widget-active);
				border: var(--border-widget-active);
				background-color: var(--color-background-widget-active);
				padding: 0.5em 0.5em;
				display: block;
			}

			.active button {
				animation: reveal 0.4s ease 0s 1 normal forwards;
				border: var(--border-widget);
				padding: 0.5em 0.5em;
				display: block;
			}

			.fixed button {
				border: var(--border-widget-fixed);
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-grey5);
			}

			.disabled button:hover {
				color: var(--color-white);
			}

			.icon {
				position: absolute;
				right: 10px;
				top: 14px;
				pointer-events: none;
				width: 11px;
				height: 11px;
				display: inline-block;
				color: var(--color-black);
			}
			.active .icon {
				display: none;
			}
        `];

		async onClick() {
			const selectedValue = this.featureValue.featureValueId;
			this.dispatchEvent(new CustomEvent('select-value', { bubbles: true, composed: true, detail: { selectedValue: selectedValue }}));
			if (this.active) {
				await this.toggleDecision();
				// deactivate parent
				this.dispatchEvent(new CustomEvent('deactivate-combo', {bubbles: true, composed: true}));
			} else {
				// activate parent
				this.dispatchEvent(new CustomEvent('activate-combo', {bubbles: true, composed: true}));
			}
		}

		//async onClick() {
		//	console.log('Button clicked');
		//	if (this.active) {
		//		await this.toggleDecision();
		//		const selectedValue = this.featureValue.featureValueId;
		//		this.dispatchEvent(new CustomEvent('select-value', { bubbles: true, composed: true, detail: { selectedValue }}));
		//		this.dispatchEvent(new CustomEvent('deactivate-combo', { bubbles: true,composed: true, detail: { selectedValue }}));
		//	} else {
		//		const selectedValue = this.featureValue.featureValueId;
		//		this.dispatchEvent(new CustomEvent('activate-combo', {bubbles: true, composed: true, detail: { selectedValue }}));
		//	}
		//}

	render() {
		return html`
		<div class="item ${classMap({active: this.active, unsatisfied: !this.satisfied, selected: this.isIncluded(), disabled: !this.canBeIncluded(), hideDisabled: this.hideDisabled, fixed: !this.canBeExcluded()})}">
				<button @click="${this.onClick}">
					 <trans-label key="${this.feature.variableId}" value="${this.featureValue.featureValueId}" context="FV"></trans-label>
					<span class="icon">${arrowDown}</span>
				</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.getInfoText()}
						</div>
					</div>
				`)}
			</div>
		`;
	}
}
